import { render } from "./StaffingRequirementList.vue?vue&type=template&id=5ab37b2e&scoped=true"
import script from "./StaffingRequirementList.vue?vue&type=script&lang=js"
export * from "./StaffingRequirementList.vue?vue&type=script&lang=js"

import "./StaffingRequirementList.vue?vue&type=style&index=0&id=5ab37b2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab37b2e"]])

export default __exports__